// Description: Page to choice the list to add
// Updated: 26/09/2025

// React Components and DOM Elements
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Material UI Components
import Box from "@mui/material/Box";

import CardListG from "../../components/CardList/CardListG";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import Loading from "../../components/Loading/Loading";
import Titles from "../../components/Titles/Titles";
import use123zapStore from "../../context/123zapStore";
import { Button } from "@mui/material";
import { consultRegisteredIntegrations } from "../../api/aws/Integrations/listRegisteredIntegrations";
import Footer from "../../components/Footer/Footer";

// Render The Page
function AddSheetsOptions() {
  const planoAtual = use123zapStore((state) => state.planoAtual);
  const registeredERPS = use123zapStore((state) => state.registeredERPS);
  const setRegisteredERPS = use123zapStore((state) => state.setRegisteredERPS);
  const alreadyFetchRegisteredERPS = use123zapStore(
    (state) => state.alreadyFetchRegisteredERPS
  );
  const setAlreadyFetchRegisteredERPS = use123zapStore(
    (state) => state.setAlreadyFetchRegisteredERPS
  );
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  const mapPlanFunctionsAllowed = {
    FreeZap: [],
    StartZap: [
      "WhatsApp Web",
      "WhatsApp API",
      "Google Planilhas",
      "API",
      "Excel",
      "ERP",
    ],
    ProZap: [
      "WhatsApp Web",
      "WhatsApp API",
      "Google Planilhas",
      "API",
      "Excel",
      "ERP",
    ],
    UltraZap: [
      "WhatsApp Web",
      "WhatsApp API",
      "Google Planilhas",
      "API",
      "Excel",
      "ERP",
      "SMS",
    ],
  };

  const HandleRedirectAddGoogle = () => {
    navigate("/listagens/adicionar/google");
  };

  const HandleRedirectAddAPI = () => {
    navigate("/listagens/adicionar/api");
  };

  const HandleRedirectAddExcel = () => {
    navigate("/listagens/adicionar/excel");
  };

  const HandleRedirectERP = (erp) => {
    navigate(`/listagens/adicionar/${finalUrl(erp)}`);
  };

  const canAddList = (type) => {
    if (!mapPlanFunctionsAllowed[planoAtual]) {
      return false;
    }
    return mapPlanFunctionsAllowed[planoAtual].includes(type);
  };
  const [listData, setListData] = useState([
    {
      title: "Google Planilhas",
      subtitle: "Gerencie suas listagens online",
      text: "Facilite a organização e o envio de suas listagens utilizando a integração com o Google Planilhas.",
      icon: "Google",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: HandleRedirectAddGoogle,
      pago: () => canAddList("Google Planilhas"),
    },
    {
      title: "Requisição Web (API)",
      subtitle: "Adicione listagens automaticamente",
      text: "A integração via API permite adicionar e atualizar listagens de forma dinâmica e escalável.",
      icon: "API",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: HandleRedirectAddAPI,
      pago: () => canAddList("API"),
    },
    {
      title: "Arquivo Excel",
      subtitle: "Importe listagens de arquivos excel",
      text: "Crie uma listagem a partir da importação de um arquivo Excel.",
      icon: "Newspaper",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: HandleRedirectAddExcel,
      pago: () => canAddList("Excel"),
    },
    {
      title: "Adicionar integração",
      subtitle: "Conecte novos sistemas parceiros",
      text: "Adicione sistemas parceiros de forma prática e rápida.",
      icon: "Plus",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => navigate("/integracoes"),
      pago: () => null,
    },
  ]);

  const finalUrl = (erp) => {
    if (erp === "SGP") {
      return "sgp";
    } else if (erp === "Controllr ISP") {
      return "controllr";
    } else if (erp === "HubSoft") {
      return "hubsoft";
    } else if (erp === "EliteSoft") {
      return "elitesoft";
    } else if (erp === "Sienge") {
      return "sienge";
    }
  };

  useEffect(() => {
    if (!planoAtual) return;

    if (alreadyFetchRegisteredERPS === false) {
      setLoading(true);

      consultRegisteredIntegrations()
        .then((response) => {
          const mappedData = response.data.map((item) => ({
            title: item.integration_title,
            icon: item.integration_logo,
            onClick: () => HandleRedirectERP(item.integration_title),
            pago: () => canAddList("ERP"),
            status: item.status,
          }));

          setRegisteredERPS(mappedData);
          setAlreadyFetchRegisteredERPS(true);

          // 👉 Mantém tudo, mas garante que "Adicionar integração" fica sempre no final
          setListData((prev) => {
            const withoutAddIntegracao = prev.filter(
              (i) => i.title !== "Adicionar integração"
            );
            const addIntegracao = prev.find(
              (i) => i.title === "Adicionar integração"
            );
            return [...withoutAddIntegracao, ...mappedData, addIntegracao];
          });
        })
        .finally(() => setLoading(false));
    } else if (alreadyFetchRegisteredERPS === true) {
      const mappedData = registeredERPS.map((item) => ({
        ...item,
        onClick: () => HandleRedirectERP(item.title),
        pago: () => canAddList("ERP"),
      }));

      setRegisteredERPS(mappedData);

      // 👉 Atualiza mantendo "Adicionar integração" no final
      setListData((prev) => {
        const withoutAddIntegracao = prev.filter(
          (i) => i.title !== "Adicionar integração"
        );
        const addIntegracao = prev.find(
          (i) => i.title === "Adicionar integração"
        );
        return [...withoutAddIntegracao, ...mappedData, addIntegracao];
      });
    }
  }, [planoAtual]);

  if (planoAtual === null) {
    return <Loading open={true} />;
  }

  return (
    <>
      <HeaderPage title="Add WhatsApp Instance" />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { sm: "calc(100vh - 100px)" },
        }}
      >
        <Box sx={{ padding: { xs: "20px", sm: "32px" } }}>
          <Titles
            styles={{ fontSize: { xs: "20px", sm: "24px" } }}
            children={"Selecione sua integração para criar as listagens"}
            color={"#848484"}
          />
          <CardListG
            data={listData}
            loading={
              loading === true || (loading === true && planoAtual === null)
                ? true
                : false
            }
            showText
          />
          <div style={{ padding: "40px 0 0 0", marginTop: "auto" }}>
            <Footer />
          </div>
        </Box>
      </Box>
    </>
  );
}

export default AddSheetsOptions;
